
const initialState = {
	categories: [],
	categoriesArray: [],
	products: null,
	product: null,
}

// REDUCERS
export const reducer = (state = initialState, action) => {
	const extractCategories = (categories, categoriesArray) => {
		categories.forEach(category => {
			let categoryObject = {}
			Object.keys(category).forEach(field => {
				if (field != 'sub_categories') {
					categoryObject[field] = category[field]
				}
			})
			categoriesArray.push(categoryObject)
			extractCategories(category.sub_categories, categoriesArray)
		})
		return categoriesArray
	}

	switch (action.type) {
		case 'loadCategories@products': {
			let categoriesArray = extractCategories(action.data, [])
			return {
				...state,
				categories: action.data,
				categoriesArray: categoriesArray
			}
		}

		case 'loadProducts@products': {
			return {
				...state,
				products: action.products,
				product: null,
			}
		}

		case 'loadProduct@products': {
			return {
				...state,
				products: null,
				product: action.product,
			}
		}

		default: return state
	}
}
